export function shouldUsePublishTermsV3(userId: number, percentage: number): boolean {
  const userIdMod = userId % 100;

  return userIdMod < percentage;
}
